import styled from "styled-components";

export const AdvertisementAnchor = styled.a`
  display: flex;
  justify-content: center;
  padding: 16px 0;
`;
